import styled from 'styled-components';
import { CssSize } from '@xbcb/ui-types';

export const StyledDiv = styled.div`
  max-width: ${CssSize.MEDIUM};
`;
